import React from "react";

const steps = [
  {
    n: "01",
    title: "Diagnose",
    body:
      "Walk-the-floor inspection, HIRA mapping, document review, conversations with operators and supervisors. We surface where risk actually lives.",
  },
  {
    n: "02",
    title: "Architect",
    body:
      "Build the control framework: SOPs, PTW, training matrix, MOC governance and reporting cadence — calibrated to your operating reality.",
  },
  {
    n: "03",
    title: "Implement",
    body:
      "Train teams, deploy SAP EHS workflows and Power BI dashboards, run shadow audits, close gaps. The work shows up on the shop floor.",
  },
  {
    n: "04",
    title: "Sustain",
    body:
      "Quarterly health-checks, audit-ready evidence library, leading-indicator reviews, and continuous coaching of your in-house EHS leaders.",
  },
];

export default function Approach() {
  return (
    <section
      data-testid="approach"
      className="bg-bgalt border-t border-line"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <p className="mono-label">The engagement</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight mt-5 leading-[0.95]">
              Four phases. One
              <br />
              <span className="text-accent-red">auditable</span> system.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-ink/70 leading-relaxed">
              No clipboards-and-checklists theatre. Every step produces a
              tangible artefact — a document, a dashboard, or a verifiable
              behaviour change on the floor.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-line bg-white">
          {steps.map((s) => (
            <div
              key={s.n}
              data-testid={`approach-step-${s.n}`}
              className="border-r border-b border-line p-8 lg:p-10 min-h-[260px] relative group hover:bg-bgdark hover:text-white transition-colors"
            >
              <div className="font-mono text-xs text-ink-muted group-hover:text-white/50">
                Phase {s.n}
              </div>
              <h3 className="font-display text-3xl uppercase tracking-tight mt-6 leading-tight">
                {s.title}
                <span className="text-accent-amber">.</span>
              </h3>
              <p className="mt-4 text-sm leading-relaxed group-hover:text-white/75">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
